import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from '../config';
import { FaArrowLeft } from 'react-icons/fa';
import axios from "axios";

export default function ProductListPage() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const authToken = JSON.parse(localStorage.getItem("authToken"));
  const savedOrder = JSON.parse(localStorage.getItem("orderData")) || null;
  const reference = localStorage.getItem("paystack_ref");

  // 🔹 Create Order function
  const CreateOrder = useCallback(async () => {
    try {
      if (!savedOrder) {
        alert("No order data found.");
        return;
      }
      setLoading(true);

      console.log("📦 Sending order payload to Paystack:", {
        reference,
        cart: savedOrder.cart,
        total_price: savedOrder.totalPrice,
        address: savedOrder.address,
        location: savedOrder.location,
        phone1: savedOrder.phone1,
        phone2: savedOrder.phone2,
      });

      const response = await axios.post(
        `${API_URL}/orders/`,
        {
          reference,
          cart: savedOrder.cart,
          total_price: savedOrder.totalPrice,
          address: savedOrder.address,
          location: savedOrder.location,
          phone1: savedOrder.phone1,
          phone2: savedOrder.phone2,
        },
        { headers: { Authorization: `Bearer ${authToken?.access}` } }
      );

      if (response.status === 201) {
        
        localStorage.removeItem("cart");
        localStorage.removeItem("orderData");
        localStorage.removeItem("paystack_ref");
        navigate("/cart");
      }
    } catch (error) {
      console.error("Error creating order:", error);
      localStorage.removeItem('cart');
      localStorage.removeItem('orderData');
      localStorage.removeItem('paystack_ref');
    } finally {
      setLoading(false);
    }
  }, [savedOrder, reference, authToken, navigate]);

  // 🔹 Run CreateOrder automatically if paystack_ref exists
  useEffect(() => {
    if (reference) {
      CreateOrder();
    }
  }, [reference, CreateOrder]);

  // Load cart from localStorage
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(savedCart);
  }, []);

  // Fetch products
  useEffect(() => {
    if (reference) return; // ⛔ Don’t fetch products until order is resolved
    setLoading(true);
    axios.get(`${API_URL}/products/`)
      .then(res => setProducts(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [reference]);

  // Add to cart handler
  const handleAddToCart = (product) => {
    const updatedCart = [...cart, { ...product, price: parseFloat(product.price), quantity: 1 }];
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  return (
    <div className="product-list">
      <button onClick={() => navigate(-1)} className="back-button">
        <FaArrowLeft className="white-arrow" />
      </button>

      {/* 🔹 Cart Icon */}
      <div className="cart-icon" onClick={() => navigate("/cart")}>
        🛒
        {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
      </div>

      <h1>Our Store</h1>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="grid">
          {products.map(product => {
            const isInCart = cart.some(item => item.id === product.id);
            return (
              <div key={product.id} className="card">
                <img src={product.image} alt={product.name} />
                <h2>{product.name}</h2>
                <p>{product.description.slice(0, 30)}...</p>
                <p className="price">₦{product.price}</p>

                <Link to={`/product/detail/${product.id}`} className="btn">
                  View Details
                </Link>

                {isInCart ? (
                  <button className="btn added" disabled>Added</button>
                ) : (
                  <button className="btn" onClick={() => handleAddToCart(product)}>
                    Add to Cart
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}

      <style>{`
        .product-list {
          padding: 30px;
          font-family: Arial, sans-serif;
          position: relative;
        }
        h1 {
          text-align: center;
          margin-bottom: 20px;
        }
        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 20px;
        }
        .card {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          padding: 20px;
          text-align: center;
          transition: transform 0.2s ease;
        }
        .card:hover {
          transform: translateY(-5px);
        }
        .card img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          border-radius: 10px;
        }

        .loading {
          text-align: center;
          font-size: 1.2rem;
          margin: 40px 0;
          color: #2c7a7b;
          font-weight: bold;
        }
        .price {
          font-weight: bold;
          color: #2c7a7b;
          margin: 10px 0;
        }
        .btn {
          display: inline-block;
          padding: 10px 15px;
          margin: 5px;
          background: #2c7a7b;
          color: white;
          border-radius: 8px;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: background 0.3s;
        }
        .btn:hover {
          background: #285e61;
        }
        .btn.added {
          background: #ccc;
          color: #555;
          cursor: not-allowed;
        }

        /* 🔹 Cart Icon */
        .cart-icon {
          position: fixed;
          top: 200px;
          right: 20px;
          background: #2c7a7b;
          color: white;
          font-size: 24px;
          padding: 12px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cart-count {
          position: absolute;
          top: 10px;
          right: 10px;
          background: red;
          color: white;
          font-size: 14px;
          font-weight: bold;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

         
      `}</style>
    </div>
  );
}
